interface UserAgent {
  (): {
    isMobile(): boolean
  }
}

const webBrowser: UserAgent = () => ({
  isMobile: () => {
    if (typeof window === 'undefined') {
      return false
    }

    return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent)
  },
})

export const userAgent = () => webBrowser()
